import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import { AgentsItem } from './components/AgentsItem';
import * as styles from './styles.css';
import { ContactsContainer } from '../../containers/Agents/Contacts';
import { ServiceBannerContainer } from '../../containers/ServiceBannerContainer';
import { ISeller } from '../../types/newbuilding/seller';
import { InfoLink } from '../Builder/component/BuilderLinkBlock/InfoLink';
import { Layout } from '../Layout';
import { VerticalSlider } from '../VerticalSlider';

interface IBuildersAgentsProps {
  sellers: ISeller[];
  title: string;
}

export function Agents({ sellers, title }: IBuildersAgentsProps) {
  return (
    <Layout>
      <div className={styles['header']} data-testid="AgentsBlock">
        <UIHeading1 as="h2">{title}</UIHeading1>
        <ServiceBannerContainer type="seller" isMultiSeller={sellers.length > 1} />
      </div>
      <VerticalSlider containerClass={styles['slider']}>
        {sellers.map(seller => (
          <AgentsItem
            key={seller.realtyUserId}
            name={seller.name}
            avatarUrl={seller.avatarUrl}
            listingLink={<InfoLink url={seller.offersForSaleUrl} text={seller.offersForSaleText} />}
            controls={<ContactsContainer seller={seller} />}
          />
        ))}
      </VerticalSlider>
    </Layout>
  );
}
